// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NgpY","right":"styles_right__1Ynvj"};